import React from 'react';
import * as PropTypes from 'prop-types';
import Layout from './Layout';
import networkImage from './network.png';

ErrorNetwork.propTypes = {
  tips: PropTypes.string,
  onReloadBtnClick: PropTypes.func,
  reloadBtnText: PropTypes.string
};

export default function ErrorNetwork(props) {
  const { tips, onReloadBtnClick, reloadBtnText } = props;
  return (
    <Layout
      image={networkImage}
      tips={tips}
      onBtnClick={onReloadBtnClick}
      btnText={reloadBtnText}
    />
  );
}
